var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInterfaceActionsNotificationOn = function SvgInterfaceActionsNotificationOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2a1.5 1.5 0 0 0-1.5 1.5v.7C7.92 4.87 6 7.216 6 10v4.838L5.28 17H4v2h6.27a2 2 0 0 0 .316 2.414A2 2 0 0 0 14 20a2 2 0 0 0-.271-1H20v-2h-1.28L18 14.838V10c0-2.783-1.92-5.13-4.5-5.8v-.7A1.5 1.5 0 0 0 12 2m0 4c2.22 0 4 1.78 4 4v5.162L16.611 17H7.39L8 15.162V10c0-2.22 1.78-4 4-4"
  })));
};
export default SvgInterfaceActionsNotificationOn;